import { useTranslation } from "react-i18next";

const StyledVehicleDetailsUnderlinedHeading = ({ header }) => {
  const { t } = useTranslation();
  return (
    <h3 className="text-[var(--primary-dark-color)] max-md:text-lg font-semibold text-2xl pb-2 relative heading-underline">
      {t(`/vehicleDetails.${header}`)}
    </h3>
  );
};
export default StyledVehicleDetailsUnderlinedHeading;
